export const ALLOCATION_TOOL_REV_KEY: string = 'allocation_tool_rev';
export const ALLOCATION_TOOL_REV: number = 0.1;
export const ALLOCATION_SHIPMENT_DATA_RESTRUCTURE_REV: number = 0.1;
